// @ts-nocheck
/* Port of utilities/expiryDate.js from origin/main-dev — byte-identical logic. */
const pad = (n) => String(n).padStart(2, "0");

const DATE_ONLY_RE = /^(\d{4})-(\d{2})-(\d{2})$/;

export const toDateInputString = (value) => {
  if (value === null || value === undefined || value === "") return "";

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (DATE_ONLY_RE.test(trimmed)) return trimmed;
    const leading = trimmed.slice(0, 10);
    if (DATE_ONLY_RE.test(leading) && /^(\d{4}-\d{2}-\d{2})[T ]00:00:00/.test(trimmed)) {
      return leading;
    }
  }

  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";

  if (
    d.getUTCHours() === 0 &&
    d.getUTCMinutes() === 0 &&
    d.getUTCSeconds() === 0 &&
    d.getUTCMilliseconds() === 0
  ) {
    return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`;
  }

  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const todayInputString = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const minDateStr = (...values) => {
  const list = values
    .flat()
    .map((v) => toDateInputString(v))
    .filter(Boolean)
    .sort();
  return list.length ? list[0] : "";
};

export const formatExpiryForDisplay = (value) => {
  const s = toDateInputString(value);
  if (!s) return "";
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString();
};

export default {
  toDateInputString,
  todayInputString,
  minDateStr,
  formatExpiryForDisplay,
};
